const NAME = 'SENDBIRD';

export const getChannels = (store) => store[NAME].channel.list.data || [];
